window.SmallCardSlider = (randomId) => {
    return {
        swiper: null,
        init() {
          setTimeout(() => {
            this.swiper = new Swiper("#swiper-" + randomId, {
              slidesPerView: 1,
              loop: true,
              grabCursor: true,
              spaceBetween: 0,
              a11y: true,
              navigation: {
                nextEl: ".swiper-button-next-" + randomId,
                prevEl: ".swiper-button-prev-" + randomId,
              }
            });
          }, 0);
        },
      };
};
